import * as Yup from 'yup';

export const lockerReservationValidationSchema = Yup.object().shape({
  equipmentId: Yup.string()
    .required('Equipamento é obrigatório'),
  
  userId: Yup.string()
    .required('Usuário é obrigatório'),
  
  durationHours: Yup.number()
    .min(1, 'Duração deve ser pelo menos 1 hora')
    .max(24, 'Duração máxima é 24 horas')
    .required('Duração é obrigatória'),
  
}); 